import Index from './Index.vue';

export default {
  path: 'tipos',
  name: 'produto-tipo',
  component: Index,
};
